import styled from 'styled-components';
import { useQueryParamsHook } from '../../../utils/useQueryParamsHook';
import { WegetMainCoupangApiStoreList } from './wegets/weget-main-coupang-api-store-list';
import { useApiInfoContextValueHook } from '../../../contexts/ApiInfoContext';
import { useCoupangApiStoreInfoActionsContextHook } from './contexts/CoupangApiStoreInfoContext';
import { useEffect } from 'react';
import { SellertoolSignatureUtils } from '../../../utils/sellertool-signature-utils';
import { CoupangApiApi } from '../../../apis/CoupangApiApi';
import { WegetMainCollectionButton } from './wegets/weget-main-collection-button';
import { WegetViewTypeNav } from './wegets/weget-view-type-nav/weget-view-type-nav';
import WegetCollectedLayout from './wegets/weget-collected-layout/weget-collected-layout';
import { WegetCollectedSummary } from './wegets/weget-collected-summary/weget-collected-summary';
import { WegetCollectedTopButtons } from './wegets/weget-collected-top-buttons/weget-collected-top-buttons';
import { WegetCollectedTable } from './wegets/weget-collected-table/weget-collected-table';

const Container = styled.div`
    background-color: var(--backgroundField);
    min-height:100vh;
    padding-bottom: 200px;
`;

export function MainView(props) {
    const queryParamsHook = useQueryParamsHook();

    const apiInfoContextValueHook = useApiInfoContextValueHook();
    const coupangApiStoreInfoActionsContextHook = useCoupangApiStoreInfoActionsContextHook();

    useEffect(() => {
        if (!apiInfoContextValueHook?.apiInfo?.apiKey || !apiInfoContextValueHook?.apiInfo?.secretKey) {
            return;
        }

        handleFetchCoupangApiStoreInfos();
    }, [apiInfoContextValueHook?.apiInfo?.apiKey, apiInfoContextValueHook?.apiInfo?.secretKey]);

    const handleFetchCoupangApiStoreInfos = async () => {
        const timestamp = Date.now().toString();
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp
        })

        const headers = {
            'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
            'x-sellertool-timestamp': timestamp,
            'x-sellertool-signiture': signature
        }

        const fetchResult = await CoupangApiApi().searchCoupangApiStoreInfos({
            params: null,
            headers: headers
        })

        if (fetchResult?.content) {
            coupangApiStoreInfoActionsContextHook.coupangApiStoreInfos.setValue(fetchResult?.content);
        }
    }

    return (
        <>
            {(!queryParamsHook?.params?.ViewType || queryParamsHook?.params?.ViewType === 'MAIN') && (
                <Container>
                    <WegetMainCoupangApiStoreList />
                    <WegetMainCollectionButton />
                </Container>
            )}

            {(queryParamsHook?.params?.ViewType === 'COLLECTED') && (
                <Container>
                    <WegetViewTypeNav title={'주문수집'} />
                    <WegetCollectedLayout
                        sidebarItems={[{ name: 'test', count: 1 }]}
                    >
                        <WegetCollectedSummary />
                        <WegetCollectedTopButtons />
                        <WegetCollectedTable />
                    </WegetCollectedLayout>
                </Container>
            )}
        </>
    );
}